import { useItemSet } from '@exam-management/common/item-set-provider';
import { QuestionStatus } from '@exam-management/graphql';
import { Box, Flex, SectionTitle, Text } from '@shared/components';

import { InformationView } from '../information-view';
import { ItemSetSubQuestionInformationFormSection } from '../item-set-sub-question-information-form-section';

interface ItemSetSubQuestionInformationSectionProps {
  readonly?: boolean;
  onClickPStats?: () => void;
  questionStatus?: QuestionStatus;
  mode?: 'workflow' | 'qcontent';
  titleEndAdornment?: JSX.Element;
}

export default function ItemSetSubQuestionInformationSection(
  props: Readonly<ItemSetSubQuestionInformationSectionProps>,
) {
  const {
    readonly: isReadonly,
    onClickPStats,
    questionStatus = QuestionStatus.Draft,
    mode,
    titleEndAdornment,
  } = props;

  const { itemSet } = useItemSet();

  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
      <SectionTitle title='Information' endAdornment={titleEndAdornment} />
      <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(1) }}>
        <Text variant='body2Semibold'>Item Set Name</Text>
        <Box
          sx={(theme) => ({
            backgroundColor: theme.palette.grey[100],
            borderRadius: theme.shape.rounded(1),
            p: theme.spacing(2.5, 4.5),
          })}
        >
          <Text>{itemSet.name}</Text>
        </Box>
      </Flex>
      {isReadonly ? (
        <InformationView />
      ) : (
        <ItemSetSubQuestionInformationFormSection
          onClick={onClickPStats}
          status={questionStatus}
          mode={mode}
        />
      )}
    </Flex>
  );
}
